import register from '../../../../global/js/registry';
export default register('m-input-search-fat', () => import(/* webpackMode: "lazy" */ './m-input-search-fat.controller'));
